<template>
    <div id="floatWindow">
        <div class="innerWindow">
            <div class="clearfix">
                <i class="el-icon-close pull-right" title="关闭" @click="panelMouseLeave(item)"></i>
            </div>
            <ip-patent-info-panel :index="item.index" :title="item.title" :i18n-text="i18nText" :field-list="item.fieldList" :title-tag="item.titleTag"
                                    :is-show-img="false" :img-positon="item.imgPositon" :is-single-img="item.isSingleImg" :url-list="item.url"
                                    :is-show-tool="false" @drilling="handleDrilling(item, $event)">
                <template slot="title" name="title">
                    <slot name="title" :data="item"></slot>
                </template>
                <template slot="single-field" slot-scope="data">
                    <slot name="single-field" :data="data"></slot>
                </template>  
            </ip-patent-info-panel>
        </div>
    </div>
</template>
<style lang="scss" scoped>
#floatWindow{
    width: 100%;
    overflow:hidden;
    box-sizing: border-box;
    .innerWindow{
        padding: 20px;
        margin: 0 10px;
        background: #f3f3f3;
    }
}
</style>
<script>
import Vue from 'vue'
import ipPatentInfoPanel from '../../patent-info-pannel'
export default Vue.extend({
    name:'floatExtend',
    props:{
        item:{type:Object,default(){ return {}}},
        i18nText:{type:Object,default(){
          return {}
        }}
    },
    components:{ipPatentInfoPanel},
    methods:{
        handleDrilling(item,field){
            // console.log('item',item,field);
            this.$emit('drilling',item.field)
        },
        panelMouseLeave(item){
            this.$set(item,'hightLight',false);
            const floatWindow = document.querySelector('#floatWindow');
            let dom = document.querySelector("#trade-pic");
            if(floatWindow){
                dom.removeChild(floatWindow);
            }
        }
    }
})
</script>